import { Link } from "react-router-dom";
import type { NewsArticle } from "@/types";

interface NewsBriefProps {
  articles: NewsArticle[];
}

export default function NewsBrief({ articles }: NewsBriefProps) {
  return (
    <div className="flex flex-col gap-3">
      {articles.map((article) => (
        <Link
          key={article.id}
          to={`/news/${article.id}`}
          className="group flex gap-3 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300 hover:bg-background-100"
        >
          <div className="h-16 w-24 shrink-0 overflow-hidden rounded-md bg-background-200">
            <img
              src={article.image}
              alt={article.title}
              title={`${article.title} - NBA直播资讯`}
              className="h-full w-full object-top"
            />
          </div>
          <div className="min-w-0">
            <span className="inline-block rounded bg-accent-100 px-1.5 py-0.5 text-[11px] font-semibold text-accent-800">
              {article.category}
            </span>
            <h3 className="mt-1 line-clamp-2 text-sm font-semibold text-foreground-900 transition-colors group-hover:text-primary-600">
              {article.title}
            </h3>
            <p className="mt-1 text-xs text-foreground-500">{article.date}</p>
          </div>
        </Link>
      ))}
    </div>
  );
}